<template>
  <div>
    <b-alert
      variant="danger"
      :show="alertErrors.length > 0"
      class="mb-0"
    >
      <div
        v-for="(row, index) in alertErrors"
        :key="index"
        class="alert-body"
      >
        <feather-icon

          icon="InfoIcon"
          class="mr-50"
        />
        {{ row }}
      </div>
    </b-alert>
  </div>
</template>

<script>
import { BAlert } from 'bootstrap-vue'

export default {
  components: {
    BAlert,
  },

  props: {
    alertErrors: {
      type: Array,
      required: true,
    },
  },
  cerated() {
    console.log('===>', this.alertErrors)
  },
}
</script>
